import constants from '@/constants';

import * as sync from './syncer';
import companyApi from './company/companyApi';
import diaryEntryApi from './diaryEntry/diaryEntryApi';
import keywordApi from './keyword/keywordApi';
import log from '@/logger';
import partApi from './part/partApi';
import partCommentApi from './partComment/partCommentApi';
import personApi from './person/personApi';
import projectApi from './project/projectApi';
import stageApi from './stage/stageApi';
import userApi from './user/userApi';

import db from './db';

export default {
  ...companyApi,
  ...diaryEntryApi,
  ...keywordApi,
  ...partApi,
  ...partCommentApi,
  ...personApi,
  ...projectApi,
  ...stageApi,
  ...userApi,
  logOrganisationAction: function (log) {
    return db.organisationLogDb.post(log);
  },
  remapChildrenIds: function (children, list) {
    for (var child of children) {
      if (child.children) {
        this.remapChildrenIds(child.children, list);
      }
      for (var p of list) {
        if (p.originalId === child._id) {
          child._id = p._id;
        }
      }
    }
  },
  getOrganisationDbDoc: function (id) {
    return db.organisationDb.get(id).then((doc) => {
      return doc;
    });
  },
  switchDatabase: async function (id, state, dispatch) {
    await this.loadDatabase(id, state, dispatch);
    db.currentProjectLogDb = db.loadedDatabases[id + '-log'];
    db.currentProjectDb = db.loadedDatabases[id];
    // db.favoriteKeywordDb = db.loadedDatabases[id];
  },
  loadDatabase: async function (id, state, dispatch) {
    log.debug('api.loadDatabase', [id]);
    if (db.loadedDatabases.hasOwnProperty(id)) {
      return;
    }

    var logDb = await db.init(id + '-log');
    db.loadedDatabases[id + '-log'] = logDb;
    sync.replicate({ username: db.loggedInUsername, password: db.loggedInPassword }, logDb, db.DB(id + '-log'));

    var dbProps = db.DB(id);
    dbProps.username = db.loggedInUsername;
    dbProps.password = db.loggedInPassword;
    var projectDb = await db.init(id);
    await db.initViews(projectDb);
    db.loadedDatabases[id] = projectDb;
    return sync.initSync(projectDb, state, dispatch, dbProps);
  },

  async uploadS3File({ s3Key, fileArrayBuffer }) {
    if (!s3Key || fileArrayBuffer == null) {
      throw new Error('API uploadS3File: Missing params');
    }

    const url = new URL('data/uploadFile', constants.s3Api.baseUrl);
    url.searchParams.append('s3Key', s3Key);
    url.searchParams.append('token', constants.s3Api.token);

    const response = await fetch(url.toString(), { method: 'GET', headers: db.getBasicAuthHeaders() });
    if (!response.ok) {
      throw new Error('API uploadS3File: Failed to retrieve upload url from data server');
    }

    const uploadUrl = await response.json();
    const params = {
      method: 'PUT',
      body: fileArrayBuffer,
      headers: {
        'Content-Type': 'application/octet-stream',
      },
    };

    const uploadResponse = await fetch(uploadUrl, params);
    if (!uploadResponse.ok) {
      throw new Error('API uploadS3File: Failed to upload file to data server');
    }

    return true;
  },

  async fetchS3DownloadLink({ s3Key }) {
    if (!s3Key) {
      throw new Error('API fetchS3DownloadLink: Missing file key');
    }

    const url = new URL('data/file', constants.s3Api.baseUrl);
    url.searchParams.append('s3Key', s3Key);
    url.searchParams.append('token', constants.s3Api.token);

    const response = await fetch(url.toString(), { method: 'GET', headers: db.getBasicAuthHeaders() });
    if (!response.ok) {
      throw new Error('API fetchS3DownloadLink: Failed to retrieve download link from data server');
    }

    return response.json();
  },
};



// WEBPACK FOOTER //
// ./src/store/api.js